import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ContactMsg } from '../models/contact';
import { User } from '../models/user';


@Injectable({
    providedIn: 'root'
})

export class ContactService {
    controller = 'Contact';

    constructor(private base: BaseService) { }


    Send(obj: ContactMsg) {
        return this.base.save(this.controller + '/ContactUs', obj);
    }

    forgetPassword(obj: User) {
        return this.base.save(this.controller + '/ForgetPassword', obj);
    }

}